export default "__VITE_ASSET__D$rhiSsm__"